import { supabase } from './client';
import { createLogger } from '../logger';
import { WeddingInvitation, TimelineEvent } from '../../types/invitation';

const log = createLogger('ai-timeline');

export interface GeneratedTask {
  title: string;
  description: string;
  category: string;
  target_date: string;
  display_order: number;
}

export interface GenerateTimelineResult {
  success: boolean;
  tasks?: GeneratedTask[];
  error?: string;
}

export interface ExistingTaskSummary {
  title: string;
  category: string | null;
  target_date: string;
  is_completed: boolean;
}

export const aiTimelineService = {
  async generateTimeline(
    invitation: WeddingInvitation,
    existingTasks?: TimelineEvent[]
  ): Promise<GenerateTimelineResult> {
    log.debug('呼叫 AI 生成時間軸', invitation.id);

    const taskSummaries: ExistingTaskSummary[] | undefined = existingTasks?.map(t => ({
      title: t.title,
      category: t.category,
      target_date: t.target_date,
      is_completed: t.is_completed,
    }));

    try {
      const { data, error } = await supabase.functions.invoke('generate-timeline', {
        body: {
          weddingDate: invitation.weddingDate,
          brideName: invitation.brideName,
          groomName: invitation.groomName,
          venue: invitation.venue,
          hasWelcomeParty: invitation.hasWelcomeParty,
          hasWeddingCeremony: invitation.hasWeddingCeremony,
          hasReception: invitation.hasReception,
          ceremonyVenue: invitation.ceremonyVenue,
          ceremonyTime: invitation.ceremonyTime,
          receptionVenue: invitation.receptionVenue,
          receptionTime: invitation.receptionTime,
          existingTasks: taskSummaries,
        },
      });

      if (error) {
        log.error('AI 生成時間軸失敗:', error);
        return { success: false, error: error.message || 'AI 生成失敗' };
      }

      if (!data?.success) {
        log.error('AI 回應錯誤:', data);
        return { success: false, error: data?.error || 'AI 生成失敗' };
      }

      log.info('AI 成功生成', data.tasks.length, '個任務');
      return { success: true, tasks: data.tasks };
    } catch (err) {
      log.error('AI 服務呼叫異常:', err);
      return {
        success: false,
        error: err instanceof Error ? err.message : 'AI 服務暫時不可用',
      };
    }
  },

  async incrementGenerationCount(invitationId: string): Promise<void> {
    const { error } = await supabase.rpc('increment_ai_generation_count', {
      invitation_id_input: invitationId,
    });

    if (error) {
      log.error('更新 AI 生成次數失敗:', error);
      throw error;
    }
  },
};
